"use client";

import { c as _c } from "react/compiler-runtime";
import { usePathname } from "@opensea/navigation";
import { parseAsString, useQueryStates } from "nuqs";
import { useFilterDefaults } from "@/components/layout/FilterDefaultsProvider";
import { isFilterApplicable } from "@/components/search/filter-applicability";
import { QUERY_PARAM_KEYS } from "./keys";
const QUERY_STATES = Object.fromEntries(
// parseAsString is a dummy parser. Only used for typing
Object.values(QUERY_PARAM_KEYS).map(key => [key, parseAsString]));
/**
 * We have to manually clear all query params using nuqs as that doesn't cause any route changes.
 * Using router.push or shallow routing still causes a noticeable lag when clearing query params.
 *
 * https://github.com/47ng/nuqs/discussions/684#discussioncomment-10947193
 */
export const useClearFilters = options => {
  const $ = _c(13);
  let t0;
  if ($[0] !== options?.excludeKeys) {
    t0 = options?.excludeKeys ?? [];
    $[0] = options?.excludeKeys;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const excludeKeys = t0;
  const {
    statuses,
    offerStatuses,
    activityTypes,
    timeframe,
    isVerified
  } = useFilterDefaults();
  const pathname = usePathname();
  const [, setSearchParams] = useQueryStates(QUERY_STATES);
  let t1;
  if ($[2] !== excludeKeys) {
    t1 = Object.fromEntries(Object.entries(QUERY_PARAM_KEYS).filter(t2 => {
      const [key] = t2;
      return !excludeKeys.includes(key);
    }).map(_temp));
    $[2] = excludeKeys;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const QUERY_CLEARED = t1;
  let t2;
  if ($[4] !== QUERY_CLEARED || $[5] !== activityTypes || $[6] !== isVerified || $[7] !== offerStatuses || $[8] !== pathname || $[9] !== setSearchParams || $[10] !== statuses || $[11] !== timeframe) {
    t2 = () => {
      setSearchParams({
        ...QUERY_CLEARED,
        ...Object.fromEntries([statuses ? [QUERY_PARAM_KEYS.status, ["all"]] : [], timeframe ? [QUERY_PARAM_KEYS.timeframe, ["all"]] : [], offerStatuses ? [QUERY_PARAM_KEYS.offerStatus, ["all"]] : [], activityTypes ? [QUERY_PARAM_KEYS.activityTypes, ["all"]] : [], isVerified ? [QUERY_PARAM_KEYS.isVerified, false] : [], isFilterApplicable("relayers", pathname) ? [QUERY_PARAM_KEYS.relayers, ["all"]] : []].filter(_temp2))
      });
    };
    $[4] = QUERY_CLEARED;
    $[5] = activityTypes;
    $[6] = isVerified;
    $[7] = offerStatuses;
    $[8] = pathname;
    $[9] = setSearchParams;
    $[10] = statuses;
    $[11] = timeframe;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(t0) {
  const [, key_0] = t0;
  return [key_0, null];
}
function _temp2(e) {
  return e.length > 1;
}